// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1___6e6db606af6fd7aef83","cls2":"ToolsMenu-cls2___cf4911e0474f63aca70 ToolsMenu-cls1___6e6db606af6fd7aef83"};